import { Container, Button, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function Landing() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.8, ease: "easeOut" },
    }),
  };

  const staggerContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 } },
  };

  return (
    <div className="landing-container">
      {/* Hero Section */}
      <section className="hero-section d-flex flex-column justify-content-center align-items-center text-center">
        <Container>
          <motion.h1
            className="display-2 fw-bold text-gradient mb-4"
            variants={fadeUp}
            initial="hidden"
            animate="visible"
          >
            Own a Piece of Time Now⏳
          </motion.h1>
          <motion.p
            className="lead text-success mb-4"
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            custom={1.2}
          >
            Every day is unique. Claim it for yourself—once registered, that day belongs to you alone.
          </motion.p>
          <motion.div
            className="d-flex justify-content-center"
            variants={fadeUp}
            initial="hidden"
            animate="visible"
            custom={1.4}
          >
            <Button as={Link} to="/registry" variant="success" size="lg" className="me-3 shadow-lg fw-bold">
              View Registry
            </Button>
            <Button as={Link} to="/login" variant="primary" size="lg" className="shadow-lg fw-bold">
              Login
            </Button>
          </motion.div>
        </Container>
      </section>

      {/* Scarcity Section */}
      <section className="scarcity-section py-5 text-white text-center" style={{ background: "linear-gradient(120deg, #1e3a8a, #10b981)" }}>
        <Container>
          <motion.h2
            className="mb-4 fw-bold"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Scarcity Makes it Yours
          </motion.h2>
          <motion.p
            className="lead mb-4"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0.2}
          >
            Each day can only be owned by one person. Register a day, secure your ownership, and no one else can claim it unless you resell.
          </motion.p>
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            custom={0.4}
          >
            <Button as={Link} to="/registry" variant="light" size="lg" className="text-gradient fw-bold shadow-lg">
              Explore Available Days
            </Button>
          </motion.div>
        </Container>
      </section>

      {/* Features Section */}
      <section className="features-section py-5 bg-light">
        <Container>
          <motion.h2
            className="text-center mb-5 fw-bold text-gradient"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Why Claim a Moment?
          </motion.h2>
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <Row className="g-4">
              {[
                { title: "Personal Milestones", desc: "Secure your birthdays, anniversaries, or memorable days.", color: "#10b981" },
                { title: "Historic Dates", desc: "Own iconic historical moments and be part of history’s story.", color: "#1e3a8a" },
                { title: "Corporate Ownership", desc: "Claim your company’s milestones. Each event is uniquely yours.", color: "#059669" },
              ].map((item, idx) => (
                <Col md={4} key={idx}>
                  <motion.div variants={fadeUp} custom={0.2 * idx}>
                    <Card className="h-100 shadow-lg text-center border-0 p-3 hover-card">
                      <Card.Body>
                        <Card.Title style={{ color: item.color }} className="fw-bold">{item.title}</Card.Title>
                        <Card.Text>{item.desc}</Card.Text>
                      </Card.Body>
                    </Card>
                  </motion.div>
                </Col>
              ))}
            </Row>
          </motion.div>
        </Container>
      </section>

      {/* CSS */}
      <style jsx="true">{`
        .landing-container { overflow-x: hidden; position: relative; }
        .hero-section { min-height: 100vh; background: linear-gradient(160deg, #fffbea, #dbeafe); display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center; position: relative; }
        .text-gradient { background: linear-gradient(90deg, #1e3a8a, #10b981); -webkit-background-clip: text; -webkit-text-fill-color: transparent; }
        .features-section h2, .scarcity-section h2 { font-size: 2.5rem; }
        .scarcity-section p, .features-section p { font-size: 1.3rem; max-width: 700px; margin: 0 auto; }
        .hover-card { transition: transform 0.3s ease, box-shadow 0.3s ease; }
        .hover-card:hover { transform: translateY(-10px); box-shadow: 0 20px 40px rgba(0,0,0,0.2); }
      `}</style>
    </div>
  );
}
